import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const scrollbar: SxStyleFunc<{ height: string }> = ({ height }) => ({
  height: height,
});
